// WP-0.7 (§18.1 layout frame): the app chrome around every authenticated screen —
// responsive sidebar + top bar + centered content (max-width 1280), a mobile bottom nav,
// and the mobile "Menu (everything else)" sheet.
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AlertBanner } from './AlertBanner';
import { AppLockOverlay } from './AppLockOverlay';
import { AppShellError } from './AppShellError';
import { BottomNav } from './BottomNav';
import { MobileMenu } from './MobileMenu';
import { OfflineBanner } from './OfflineBanner';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

export function AppShell(): React.JSX.Element {
  const [collapsed, setCollapsed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="flex h-full flex-col">
      {/* WP-C1.7 (ST-4, SE-1): renders nothing while unlocked; a full-screen PIN prompt over
          everything else once locked (idle timeout or manual "Lock now"). */}
      <AppLockOverlay />
      <div className="flex min-h-0 flex-1">
        {/* Sidebar owns its own responsive visibility (hidden <640, rail 640–1024, full ≥1024). */}
        <Sidebar collapsed={collapsed} />
        <div className="flex min-w-0 flex-1 flex-col">
          <TopBar
            onToggleSidebar={() => {
              setCollapsed((c) => !c);
            }}
          />
          <main className="flex-1 overflow-y-auto">
            <OfflineBanner />
            <AlertBanner />
            <div className="mx-auto max-w-[1280px] px-[var(--gutter)] py-6">
              <AppShellError>
                <Outlet />
              </AppShellError>
            </div>
          </main>
        </div>
      </div>
      <BottomNav
        onOpenMenu={() => {
          setMenuOpen(true);
        }}
      />
      <MobileMenu
        open={menuOpen}
        onClose={() => {
          setMenuOpen(false);
        }}
      />
    </div>
  );
}
